export const CONST = {
  CLAIMED_USER_SCOPES: ['*'],
  LOCAL_STORAGE_PREFIX: 'USH_',
  MIN_PASSWORD_LENGTH: 7,
  MAX_PASSWORD_LENGTH: 64,
  FORMAT_DATE: 'YYYY-MM-DD',
  FORMAT_DATE_TIME: 'YYYY-MM-DD HH:mm',
};
